// Sugalarm — /api/pairing wrappers.

import { request } from "../lib/apiClient";
import type { ApiResult } from "../lib/types";

export type PairingStatus =
  | "pending"
  | "approved"
  | "consumed"
  | "expired"
  | "revoked";

export interface PairingRequestIn {
  requested_device_name?: string;
  requested_device_type?: "kiosk" | "web" | "mobile" | "other";
  // Cycle 131: the client's stable, localStorage-persisted device id, so
  // a re-pair of the same physical unit reuses its existing devices row
  // instead of stacking a new one. Optional + backward-compatible.
  client_device_id?: string;
}

export interface PairingRequestOut {
  pairing_id: string;
  code: string;
  expires_at: string;
  poll_interval_seconds: number;
}

export interface PairingPollOut {
  status: PairingStatus;
  device_token?: string;
  device_id?: string;
}

export interface PairingApproveIn {
  code: string;
  device_name?: string;
  device_type?: "kiosk" | "web" | "mobile" | "other";
}

export function createPairing(
  body: PairingRequestIn = {},
): Promise<ApiResult<PairingRequestOut>> {
  // No auth — the kiosk has no credentials yet.
  return request<PairingRequestOut>("/api/pairing/request", {
    method: "POST",
    body,
    noAuth: true,
  });
}

export function pollPairing(pairingId: string): Promise<ApiResult<PairingPollOut>> {
  return request<PairingPollOut>(`/api/pairing/poll/${pairingId}`, { noAuth: true });
}

export function approvePairing(body: PairingApproveIn): Promise<ApiResult<void>> {
  // JWT only — backend returns 403 for device-token bearer.
  return request<void>("/api/pairing/approve", { method: "POST", body });
}
